import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, projLink = "" }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <a href={projLink} target="_blank" style={{ color: "white" }}>
          <div className="proj-txtx">
            <h4>{title}</h4>
            <span>{description}</span>
            <h6>Click to Visit Website..</h6>
          </div>
        </a>
      </div>
    </Col>
  );
};
